import LokiJSAdapter from '@nozbe/watermelondb/adapters/lokijs'
import { DBInstance } from '../core'
import migrations from '../core/migrations'
import schema from '../core/schema'

export const webAdapter = new LokiJSAdapter({
  schema,
  migrations,
  dbName: 'wingo-chat-web-db',
  useWebWorker: false,
  useIncrementalIndexedDB: true,
  onQuotaExceededError: error => {
    console.error('Quota Exceeded Error:', error)
  },
  onSetUpError: error => {
    console.error('Database failed to load:', error)
  },
  extraIncrementalIDBOptions: {
    onDidOverwrite: () => {
      console.info('Database onDidOverwrite')
    },
    onversionchange: () => {
      console.info('On version change')
      window.location.reload()
    }
  }
})

export const dbInstance = new DBInstance(webAdapter)
